define('boxes/controllers/box-controller',['jquery', 'all/slider', 'boxes/helpers/box-loading', 'all/tracking-event', 'all/comeon'], function($, slider, boxLoading, trackingEvent, comeon) {
    'use strict';

    function addOpenedTrackingEvent(boxController, $box) {
        if(!$box.data('trackingName') || !boxController.$controller.data('trackingName')) {
            return;
        }

        trackingEvent.add(
            boxController.$controller.data('trackingName'),
            $box.data('trackingName'),
            'opened'
        );
    }

    function toBoxIndex(boxController, sliderFunction) {
        var currentBox = boxController.boxes[boxController.currentBoxIndex],
            promise = currentBox.render(currentBox),
            slidedPromise = comeon.promise.create();
        currentBox.box().hide();
        $.when(promise)
            .done(function() {
                boxLoading.removeLoading(currentBox.box());
                sliderFunction(currentBox.box());
                addOpenedTrackingEvent(boxController, currentBox.box());
                slidedPromise.resolve();
            })
            .fail(function () {
                nextBox(boxController);
                slidedPromise.reject();
            });
        return slidedPromise;
    }

    function closeBox(boxController) {
        if(boxController.currentBoxIndex < 0) {
            return;
        }
        var currentBox = boxController.boxes[boxController.currentBoxIndex];
        currentBox.close(currentBox);
    }

    function nextBox(boxController) {
        closeBox(boxController);
        boxController.currentBoxIndex += 1;
        return toBoxIndex(boxController, slider.slideStep);
    }

    function start(boxController, setupFunction, startIndex) {
		if(startIndex === 0)
			boxController.currentBoxIndex = startIndex;
		else
        	boxController.currentBoxIndex = startIndex || -1;
        if (boxController.initialized === false) {
            setupFunction();
            boxController.initialized = true;
        }
        window.scrollTo(0, 0);
        boxController.$controller.show();
        nextBox(boxController);
    }

    function previousBox(boxController) {
        closeBox(boxController);
        boxController.currentBoxIndex -= 1;
        return toBoxIndex(boxController, slider.slideBack);
    }

    function findBoxIndex(boxController, box) {
        var i;
        for(i = 0; i < boxController.boxes.length; i += 1) {
            if (boxController.boxes[i] === box) {
                return i;
            }
        }
        return boxController.currentBoxIndex;
    }

    function goToBox(boxController, box) {
        closeBox(boxController);
        boxController.currentBoxIndex = findBoxIndex(boxController, box);
        return toBoxIndex(boxController, slider.slideBack);
    }

    var boxControllerPrototype = {
        find: function(selector) { return this.$controller.find(selector); },
        setBoxes: function(boxes) { this.boxes = boxes; },
        nextBox: function() {
            nextBox(this);
        },
        previousBox: function() {
            previousBox(this);
        },
        goToBox: function(boxInstance) { goToBox(this, boxInstance); },
        trigger: function(type, data) {
            this.$controller.trigger(type, data);
        },
        on: function(types, selector, data, fn) {
            this.$controller.on(types, selector, data, fn);
        },
        start: function(setupFunction, startIndex) {
            start(this, setupFunction, startIndex);
        },
        setSelector: function(selector) {
            this.$controller = $(selector);
        }
    };

    function create(selector) {
        function F() {}
        F.prototype = boxControllerPrototype;
        var instance = new F(),
            localVariables = {
                $controller: $(selector, parent.document.body),
                currentBoxIndex: -1,
                boxes: [],
                initialized: false
            };
        $.extend(instance, localVariables);
        return instance;
    }

    return {
        create: create
    };
});

